"use strict";
// This file contains objects documented here: https://api.slack.com/reference/block-kit/composition-objects
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=composition-objects.js.map